// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"68":"mv-printbutton","133":"mv-handsfree","218":"mv-reviews","520":"mv-pinbutton"}[chunkId] || chunkId) + ".chunk." + {"36":"f3725","68":"a4754","133":"f506c","218":"b4171","520":"a339b"}[chunkId] + ".js";
};